<template>
  <teleport to="body">
    <transition>
      <div
        v-if="visible && hasContactTooltipData(contact)"
        class="py-2 px-4 space-y-1 rounded-12 shadow-raised bg-bg-base-bg1 fixed z-50 pointer-events-none"
        data-test="contact-tooltip"
        :style="{
          top: `${(mouseY || 0) + 10}px`,
          left: `${(mouseX || 0) + 10}px`,
        }"
      >
        <p
          v-if="contact.name"
          data-test="contact-tooltip-name"
          class="text-body-m-15-22"
        >
          {{ contact.name }}
        </p>
        <p
          v-if="contact.internalNumber && contact.internalNumber !== contact.name"
          data-test="contact-tooltip-internalnumber"
          class="text-body-r-14-20 text-fg-base-fg22"
        >
          {{ contact.internalNumber }}
        </p>
        <p
          v-if="contact.mobilePhone && contact.mobilePhone !== contact.name"
          data-test="contact-tooltip-mobilephone"
          class="text-body-r-14-20 text-fg-base-fg22"
        >
          {{ contact.mobilePhone }}
        </p>
      </div>
    </transition>
  </teleport>
</template>

<script lang="ts" setup>
import { ContactTooltipData, hasContactTooltipData } from '@/entities/contact'

defineProps<{
  contact: ContactTooltipData
  visible: boolean
  mouseX: number | null
  mouseY: number | null
}>()
</script>

<style lang="css" scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
